import { render, staticRenderFns } from "./cookieNotification.vue?vue&type=template&id=c5731002&scoped=true"
import script from "./cookieNotification.vue?vue&type=script&lang=js"
export * from "./cookieNotification.vue?vue&type=script&lang=js"
import style0 from "./cookieNotification.vue?vue&type=style&index=0&id=c5731002&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5731002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5731002')) {
      api.createRecord('c5731002', component.options)
    } else {
      api.reload('c5731002', component.options)
    }
    module.hot.accept("./cookieNotification.vue?vue&type=template&id=c5731002&scoped=true", function () {
      api.rerender('c5731002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cookieNotification.vue"
export default component.exports